import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import CommentEditor, {
  ICommentEditorProps,
  ICommentEditorUIProps,
} from '../components/CommentEditor'
import { actionCreators, selectComment } from '../modules/commentEditor'

export default connect(
  (state: ApplicationState, ownProps: ICommentEditorUIProps) =>
    createStructuredSelector<
      ApplicationState,
      ICurrentUserState & ICommentEditorProps
    >({
      comment: selectComment(ownProps.contextId),
      user: selectCurrentUser(),
    }),
  actionCreators,
)(CommentEditor)
